import { createContext, useContext, useEffect } from 'react'

/** Чем занята касса: корзина пуста, набирается корзина, идёт оплата или пробитие чека. */
export type SaleActivity = 'idle' | 'cart' | 'paying'

/**
 * Куда экран продажи сообщает, чем занята касса (RP-MNT: пульт обновления видит каждую РМК). Ставит оболочка вокруг окна РМК;
 * вне неё — `null`, экран никуда не сообщает.
 */
export const SaleActivityContext = createContext<((activity: SaleActivity) => void) | null>(null)

/** Экран продажи сообщает своё занятие; ушёл с экрана — касса свободна. */
export function useReportSaleActivity(activity: SaleActivity): void {
  const report = useContext(SaleActivityContext)
  useEffect(() => {
    report?.(activity)
  }, [activity, report])
  useEffect(() => () => report?.('idle'), [report])
}
